/* eslint-disable no-nested-ternary */
import ProdutoModel from 'models/Produto';
import ProdutoCategoria from 'models/ProdutoCategoria';
import { useEffect, useState } from 'react';
import { FaEdit, FaUndo } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {
  Row,
  Button,
  Card,
  Input,
  CardHeader,
  Table,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Badge,
  DropdownItem,
} from 'reactstrap';
import api from 'services/api';
import ModalUploadImagem from 'components/ModalUploadImagem';
import Compress from 'compress.js';
import OpcaoMostrarBotoes from 'staticData/OpcaoMostrarBotoes';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import CampoBuscaFiltrarLista from 'utils/CampoBuscaFiltrarLista';
import styled from 'styled-components';
import ModalProduto from '../ModalProduto';

interface ProdutoAssociado {
  produtoRelacao: {
    id: number;
    nome: string;
  };
}

interface Props {
  produtos: ProdutoModel[];
  produtoCategorias: ProdutoCategoria[];
  carregaProdutos: () => void;
  mostrarDesativados: boolean;
}

type Option = {
  label: string;
  value: number;
};

const DropDownItemStyled = styled(DropdownItem)`
  background: none !important;
  border: none !important;

  display: flex;
  width: 100%;
  padding: 0.5rem 1rem;

  justify-content: center;
  align-items: center;

  margin: 0;

  color: #0d6efd !important;
  cursor: pointer;

  font-size: 1rem;
  font-weight: 500;
  text-decoration: none !important;

  &:hover,
  &:focus {
    background-color: rgba(13, 110, 253, 0.1) !important;
    color: #0a58ca !important;
    text-decoration: none !important;
    box-shadow: none !important;
  }
`;

export default function ListaProdutos({
  produtos,
  produtoCategorias,
  carregaProdutos,
  mostrarDesativados,
}: Props): JSX.Element {
  const [formModalState, setFormModalState] = useState(false);
  const [produtoEditing, setProdutoEditing] = useState({} as ProdutoModel);
  const [produtoSelecionado, setProdutoSelecionado] = useState<ProdutoModel>();
  const [exibirModalImagem, setExibirModalImagem] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [opcaoMostrarBotoes, setOpcaoMostrarBotoes] = useState('4');
  const [produtosSelecao, setProdutosSelecao] = useState<any[]>([]);
  const [produtosAssociadosIniciais, setProdutosAssociadosIniciais] = useState<
    ProdutoModel[]
  >([]);
  const [produtosAssociados, setProdutosAssociados] = useState<Option[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [resultadoFiltrado, setResultadoFiltrado] = useState(
    [] as ProdutoModel[],
  );

  useEffect(() => {
    carregaProdutos();
  }, []);

  async function handleDelete(produto: ProdutoModel) {
    if (!produto) return;

    async function checkExistePartesProduto(): Promise<{
      existePartes: boolean;
      tamanho: number;
    }> {
      const response = await api.get(`/produto/${produto.id}/partes`);
      const existePartes = !!response.data.length;
      return { existePartes, tamanho: response.data.length };
    }

    const { existePartes, tamanho } = await checkExistePartesProduto();

    if (existePartes) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        html: ` <h4 className="heading mt-4">
                Não é possível desativar o produto!
              </h4>
              <p>
                Esse produto possui
                ${tamanho} ${
          tamanho > 1 ? 'partes cadastradas.' : 'parte cadastrada.'
        }
                ${
                  tamanho > 1 ? 'remova-as' : 'remova-a'
                } para prosseguir com a desativação do produto.
              </p>`,
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: '#d33',
        cancelButtonText: `Fechar`,
      });
    } else {
      Swal.fire({
        title: `Deseja desativar o produto ${produto.nome}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, desativar`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      }).then(async result => {
        if (result.isConfirmed) {
          await api.delete(`/produto/${produto.id}`);
          carregaProdutos();
          Swal.close();
          toast.success('Registro desativado!');
        }
      });
    }
  }

  async function comprimeImagem(imagem: string | null): Promise<string> {
    if (!imagem) {
      return '';
    }
    const compress = new Compress();
    const file = Compress.convertBase64ToFile(imagem?.split('base64,')[1]);
    const fileCompressed = await compress.compress([file], {
      quality: 0.7,
      maxWidth: 600,
      maxHeight: 640,
      resize: true,
    });
    return fileCompressed[0].data;
  }

  async function pegaProdutosAssociados(produtoId: number) {
    const response = await api.get(`/produto/produtos-associados/${produtoId}`);
    setProdutosAssociadosIniciais(response.data);
    const prodAssociados: ProdutoAssociado[] = response.data;
    const options = prodAssociados.map(prod => ({
      label: prod.produtoRelacao.nome,
      value: prod.produtoRelacao.id,
    }));
    setProdutosAssociados({
      // ...produtosSelecao,
      ...options,
    });
  }

  function handleOpenModalEdicaoProduto(produto: ProdutoModel) {
    pegaProdutosAssociados(produto.id);
    setProdutoEditing(produto);
    setFormModalState(!formModalState);
    setProdutosSelecao(produtos.filter(prod => prod.id !== produto.id));
  }

  async function handleUpdateProduto() {
    setIsLoading(true);
    toast.loading('Salvando...', { position: 'top-center' });
    const {
      nome,
      codigoEmpresa,
      produtoCategoriaId,
      nomeProposta,
      bloquearProdutosDiferentes,
      geraGnf,
      opcaoMostrarBotoes,
      permiteFatDireto,
    } = produtoEditing;
    if (!nome || !codigoEmpresa || !produtoCategoriaId) {
      return;
    }
    await api.put(`/produto/${produtoEditing.id}`, {
      nome,
      codigoEmpresa,
      produtoCategoriaId,
      nomeProposta,
      bloquearProdutosDiferentes,
      geraGnf,
      opcaoMostrarBotoes,
      produtoPrincipalId: produtoEditing.id,
      produtosARelacionar: produtosAssociados,
      finame: produtoEditing.finame,
      setorAtividade: produtoEditing.setorAtividade,
      ncm: produtoEditing.ncm,
      produtosAssociadosIniciais,
      permiteFatDireto,
    });

    setFormModalState(false);
    setProdutoEditing({} as ProdutoModel);
    carregaProdutos();
    setIsLoading(false);
    toast.dismiss();
    toast.success('Produto salvo');
  }

  function mostrarSetorAtividadeProduto(produto: ProdutoModel) {
    if (produto.setorAtividade) {
      if (produto.codigoEmpresa) {
        return `${produto.setorAtividade} (${produto.codigoEmpresa})`;
      }
      return `${produto.setorAtividade}`;
    }
    if (produto.codigoEmpresa) {
      return `${produto.codigoEmpresa}`;
    }
    return '';
  }

  function InputSelectProdutoCategoria(): JSX.Element {
    return (
      <Input
        placeholder="Categoria"
        type="select"
        value={produtoEditing.produtoCategoriaId || ''}
        onChange={text =>
          setProdutoEditing({
            ...produtoEditing,
            produtoCategoriaId: Number(text.target.value),
          })
        }
      >
        <option value="">Categoria...</option>
        {produtoCategorias.map(produtoCategoria => (
          <option value={produtoCategoria.id}>
            {produtoCategoria.descricao}
          </option>
        ))}
      </Input>
    );
  }

  function InputSelectPermiteBotoes(): JSX.Element {
    return (
      <Input
        placeholder="Mostrar nas telas"
        type="select"
        value={produtoEditing.opcaoMostrarBotoes || ''}
        onChange={text =>
          setProdutoEditing({
            ...produtoEditing,
            opcaoMostrarBotoes: Number(text.target.value),
          })
        }
      >
        {OpcaoMostrarBotoes.map(op => (
          <option value={op.id}>{op.label}</option>
        ))}
      </Input>
    );
  }

  function reativarProduto(produto: ProdutoModel) {
    Swal.fire({
      title: `Deseja reativar o produto ${produto.nome}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, reativar`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        await api.put(`/produto/${produto.id}/reativar`);
        carregaProdutos();
        Swal.close();
        toast.success('Registro reativado!');
      }
    });
  }

  useEffect(() => {
    if (produtoSelecionado) {
      setExibirModalImagem(true);
    }
  }, [produtoSelecionado]);

  function closeModalImagem() {
    setExibirModalImagem(!exibirModalImagem);
    setProdutoSelecionado(undefined);
  }

  async function salvarImagem(imagem: string | null) {
    // if (!produtoSelecionado?.id) return;
    try {
      setLoading(true);
      const imagemComprimida = await comprimeImagem(imagem);
      await api.put(`/produto/imagem`, {
        id: produtoSelecionado?.id,
        imagem: imagemComprimida || null,
        nome: produtoSelecionado?.nome,
      });
    } finally {
      setLoading(false);
      closeModalImagem();
    }
    carregaProdutos();
  }

  function mostrarBadges(produto: ProdutoModel) {
    const badges: JSX.Element[] = [];

    if (produto.bloquearProdutosDiferentes) {
      badges.push(
        <Badge style={{ backgroundColor: '#9fccca' }} key="bloqueia">
          Bloqueia Produtos Diferentes
        </Badge>,
      );
    }

    if (produto.permiteFatDireto) {
      badges.push(
        <Badge style={{ backgroundColor: '#d1d4d4' }} key="fat-direto">
          Fat. Direto
        </Badge>,
      );
    }

    badges.push(
      <Badge
        color={`${produto.geraGnf ? 'info' : 'warning'}`}
        key="tipo-geracao"
      >
        {produto.geraGnf
          ? 'Gera GNF'
          : produto.geraPedido
          ? 'Gera Pedido'
          : 'Gera PS'}
      </Badge>,
    );

    return badges;
  }

  return (
    <Row>
      <div className="col">
        <ModalUploadImagem
          isOpen={exibirModalImagem}
          toggle={closeModalImagem}
          onSave={salvarImagem}
          imagem={produtoEditing?.imagem || ''}
          descricao={produtoSelecionado?.nome || ''}
        />

        {formModalState && (
          <ModalProduto
            produtos={produtos}
            carregaProdutos={carregaProdutos}
            produtoCategorias={produtoCategorias}
            produtoEditing={produtoEditing}
            setFormModalState={setFormModalState}
            formModalState={formModalState}
            setProdutoEditing={setProdutoEditing}
            produtosAssociados={produtosAssociados}
            setProdutosAssociados={setProdutosAssociados}
            produtosSelecao={produtosSelecao.filter(
              item => item.disabledAt === null,
            )}
            isCreate={false}
          />
        )}

        <Card className="shadow">
          <CardHeader className="border-0">
            <Col>
              <h3 className="mb-0">Lista de produtos</h3>
            </Col>
            <Col>
              <CampoBuscaFiltrarLista
                lista={produtos}
                setState={setResultadoFiltrado}
                camposBuscar={[
                  p => p.codigoEmpresa,
                  p => p.nome,
                  p => p.setorAtividade,
                  p => p.ProdutoCategoria?.descricao,
                ]}
                largura={20}
              />
            </Col>
          </CardHeader>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th>Nome</th>

                <th
                  style={{
                    width: '20%',
                  }}
                >
                  Ncm
                </th>

                <th
                  style={{
                    width: '40%',
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                  }}
                >
                  {' '}
                </th>

                <th>Categoria</th>

                <th>Setor de Atividade</th>

                <th hidden={!mostrarDesativados}>Ativo</th>

                <th> </th>
              </tr>
            </thead>

            <tbody>
              {(resultadoFiltrado.length > 0 ? resultadoFiltrado : produtos)
                .filter(item => mostrarDesativados || item.disabledAt === null)
                .map(produto => (
                  <tr key={produto.id}>
                    <td>
                      <strong>{produto.nome}</strong>
                    </td>
                    <td>
                      <strong>{produto.ncm}</strong>
                    </td>
                    <td>{mostrarBadges(produto)}</td>

                    <td>
                      <strong className="text-muted">
                        {produto?.ProdutoCategoria?.descricao}
                      </strong>
                    </td>
                    <td className="col">
                      <strong>{mostrarSetorAtividadeProduto(produto)}</strong>
                    </td>
                    <td hidden={!mostrarDesativados}>
                      {produto.disabledAt !== null ? (
                        <Badge color="danger">Não</Badge>
                      ) : (
                        <Badge color="success">Sim</Badge>
                      )}
                    </td>

                    {produto.disabledAt !== null ? (
                      <td>
                        <Button
                          size="sm"
                          className="btn-icon"
                          color="info"
                          type="button"
                          onClick={() => reativarProduto(produto)}
                        >
                          <FaUndo />
                        </Button>
                      </td>
                    ) : (
                      <td>
                        <UncontrolledDropdown
                          group
                          className="d-inline-flex align-items-center"
                        >
                          <Button
                            size="sm"
                            className="btn-icon"
                            color="warning"
                            type="button"
                            onClick={() => {
                              handleOpenModalEdicaoProduto(produto);
                            }}
                          >
                            <FaEdit />
                          </Button>

                          <DropdownToggle caret color="primary" size="sm" />

                          <DropdownMenu className="dropdown-menu-arrow" right>
                            <Link
                              to={{
                                pathname: `/admin/atividades`,
                                state: { produto },
                              }}
                            >
                              <DropDownItemStyled>
                                <span>Atividade</span>
                              </DropDownItemStyled>
                            </Link>
                            <DropdownItem divider />

                            <Link
                              to={{
                                pathname: `/admin/produto-partes`,
                                state: { produto },
                              }}
                            >
                              <DropDownItemStyled>
                                <span>Partes</span>
                              </DropDownItemStyled>
                            </Link>
                            <DropdownItem divider />

                            <Link
                              to={{
                                pathname: `/admin/variaveis-regras`,
                                state: { produto },
                              }}
                            >
                              <DropDownItemStyled>
                                <span>Variáveis</span>
                              </DropDownItemStyled>
                            </Link>
                            <DropdownItem divider />

                            <Link
                              to={{
                                pathname: `/admin/grupo-regras`,
                                state: { produto },
                              }}
                            >
                              <DropDownItemStyled>Regras</DropDownItemStyled>
                            </Link>
                            <DropdownItem divider />
                            <DropDownItemStyled
                              size="sm"
                              type="button"
                              onClick={() => {
                                setExibirModalImagem(true);
                                setProdutoSelecionado(produto);
                                setProdutoEditing({
                                  ...produtoEditing,
                                  imagem: produto?.imagem,
                                });
                              }}
                            >
                              <span>Imagem</span>
                            </DropDownItemStyled>
                            <DropdownItem divider />
                            <DropDownItemStyled
                              size="sm"
                              className="btn-icon"
                              type="button"
                              onClick={() => {
                                handleDelete(produto);
                              }}
                            >
                              <span style={{ color: 'red' }}>Desativar</span>
                            </DropDownItemStyled>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </Table>
        </Card>
      </div>
    </Row>
  );
}
